// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var IconV5 = require("../../../atoms/Icon/IconV5.bs.js");
var ButtonsV5 = require("../../atoms/Buttons/ButtonsV5.bs.js");
var MediaQuery = require("../../../../reason/common/Media/MediaQuery.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var ReactAriaComponents = require("react-aria-components");

function classesForVariant(secondary, type_) {
  if (secondary) {
    if (type_ === "error") {
      return "border border-tan-error-500 bg-tan-error-500/10 text-tan-error-700";
    } else if (type_ === "warning") {
      return "border border-tan-warning bg-tan-warning/10 text-tan-warning";
    } else if (type_ === "success") {
      return "border border-tan-success bg-tan-success/10 text-tan-success-dark";
    } else {
      return "border border-tan-blue-500 bg-tan-blue-500/10 text-tan-blue-500";
    }
  } else if (type_ === "error") {
    return "bg-tan-error-500 text-white";
  } else if (type_ === "warning") {
    return "bg-tan-warning text-white";
  } else if (type_ === "success") {
    return "bg-tan-success text-white";
  } else {
    return "bg-tan-blue-500 text-white";
  }
}

function iconOfMessageType(x) {
  if (x === "error") {
    return "attention";
  } else {
    return "tick";
  }
}

function mainClassName(secondary) {
  if (secondary) {
    return "text-base font-semibold py-2";
  } else {
    return "text-lg font-light py-2.5";
  }
}

function renderButtons(id, dismissible, handleOnDismiss, children) {
  var shouldRender = Core__Option.isSome(children) || dismissible;
  var isDesktop = MediaQuery.isDesktop();
  var onDismiss = Core__Option.getOr(handleOnDismiss, (function (param) {
          
        }));
  if (shouldRender) {
    return JsxRuntime.jsxs("div", {
                children: [
                  !isDesktop && dismissible ? JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
                          onClick: (function (param) {
                              onDismiss(id);
                            }),
                          children: "Dismiss"
                        }) : null,
                  children !== undefined ? JsxRuntime.jsx("div", {
                          children: Caml_option.valFromOption(children),
                          className: "flex flex-row"
                        }) : null,
                  isDesktop && dismissible ? JsxRuntime.jsx(ReactAriaComponents.Button, {
                          children: JsxRuntime.jsx(IconV5.make, {
                                icon: "cancel"
                              }),
                          className: (function (param) {
                              return "static text-sm float-none text-white opacity-70 hover:opacity-100 bg-transparent border-0 cursor-pointer";
                            }),
                          onClick: (function (param) {
                              onDismiss(id);
                            }),
                          type: "button"
                        }) : null
                ],
                className: "flex flex-row items-center gap-4 w-full justify-end md:w-auto"
              });
  } else {
    return null;
  }
}

function SystemMessage(props) {
  var handleOnDismiss = props.handleOnDismiss;
  var __icon = props.icon;
  var __secondary = props.secondary;
  var __dismissible = props.dismissible;
  var type_ = props.type_;
  var __time = props.time;
  var id = props.id;
  var time = __time !== undefined ? __time : 3000;
  var dismissible = __dismissible !== undefined ? __dismissible : false;
  var secondary = __secondary !== undefined ? __secondary : false;
  var icon = __icon !== undefined ? __icon : false;
  var className = secondary ? "text-base font-semibold py-2" : "text-lg font-light py-2.5";
  var styleClassName = classesForVariant(secondary, type_);
  var classNames = TailwindMerge.twMerge([
        className,
        styleClassName
      ]);
  React.useEffect((function () {
          if (handleOnDismiss === undefined) {
            return ;
          }
          if (time <= 0) {
            return ;
          }
          var timeout = setTimeout((function () {
                  handleOnDismiss(id);
                }), time);
          return (function () {
                    clearTimeout(timeout);
                  });
        }), [time]);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              icon ? JsxRuntime.jsx(IconV5.make, {
                                      icon: iconOfMessageType(type_),
                                      className: "mr-4 relative top-0.5 inline align-baseline"
                                    }) : null,
                              JsxRuntime.jsx("span", {
                                    children: props.text,
                                    className: "block sm:inline w-full sm:w-auto leading-5"
                                  })
                            ],
                            className: "leading-5 flex flex-row"
                          }),
                      renderButtons(id, dismissible, handleOnDismiss, props.children)
                    ],
                    className: TailwindMerge.twMerge([
                          "w-full mx-auto flex flex-col md:flex-row items-start md:items-center justify-between flex-wrap sm:flex-nowrap gap-4",
                          "px-4",
                          secondary ? "px-2.5" : "",
                          "max-w-[720px] md:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]"
                        ])
                  }),
              className: classNames
            });
}

var make = SystemMessage;

exports.classesForVariant = classesForVariant;
exports.iconOfMessageType = iconOfMessageType;
exports.mainClassName = mainClassName;
exports.renderButtons = renderButtons;
exports.make = make;
/* react Not a pure module */
